var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.2814 2.42143L3.81663 5.63158L8.66658 7.46625C9.39086 7.74023 9.96264 8.31201 10.2366 9.03629L12.0713 13.8862L15.2814 2.42143ZM17.254 1.68144C17.4643 0.930529 16.7723 0.238594 16.0214 0.44885L1.30582 4.56922C0.376082 4.82955 0.318595 6.12589 1.22164 6.4675L8.06509 9.05628C8.33335 9.15776 8.54512 9.36953 8.64659 9.63778L11.2354 16.4812C11.577 17.3843 12.8733 17.3268 13.1337 16.3971L17.254 1.68144Z","fill":"#C4C4C4"}));
}

Send.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Send;

Send.default = Send;
